import { render, staticRenderFns } from "./spaceSelectionDropdown.vue?vue&type=template&id=099c2d73&scoped=true&"
import script from "./spaceSelectionDropdown.vue?vue&type=script&lang=js&"
export * from "./spaceSelectionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099c2d73",
  null
  
)

export default component.exports